import React, { Fragment, useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import CustomerTicketsTable from "./CustomerTicketsTable";
import { H6, H3, Image, Btn } from "../../../AbstractElements";
import AnimatedInput from "../../Common/Component/AnimatedInput";
import CustomerTripsTable from "./CustomerTripsTable";
import { useForm } from "react-hook-form";
import { editCustomer } from "../../../Services/Customer.service";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { getCustomerDetails } from "../../../Services/Customer.service";
import BookingContext from "../../../_helper/Booking";
import { getAvatarText, showAlert } from "../../../Services/Shared.service";
import SharedDataContext from "../../../_helper/SharedData";
import EditBookCab from "../../TripManagement/BookingHistory/EditBookCab";
const CustomerProfile = () => {
  const {
    onSubmitData,
    editBookCabModal,
    bookingEditType,
    setBookingEditType,
    toggleBookCabModal,
    bookingObj,
    setBookingObj,
  } = useContext(BookingContext);

  const {
    cityData,
    airportData,
    globalCityField,
    setShowApiLoader,
    dateFilter,
    setDateFilter
  } = useContext(SharedDataContext);
  const [customerType, setCustomerType] = useState({});
  const [customerObj, setCustomerObj] = useState({});
  const { customerId } = useParams();
  const { register, handleSubmit, control, reset, resetField, getValues } =
    useForm();
    const [profileImage,setProfileImage] = useState('')
    const location = useLocation();

  useEffect(() => {
    getCustomerDetails(customerId).then((customerRes) => {
      const data = customerRes.data;
      if (data) {
        reset({
          fullName: data.fullName,
          mobile: data.mobile,
          email: data.email,
          city: data.city,
        });
        const letter=getAvatarText(data?.fullName);
        setProfileImage(letter);
        setCustomerObj(data);
        setCustomerType({
          isVip: data.isVip,
          isCorporateAccount: data.isCorporateAccount,
          isInternational: data.isInternational,
        });
        setBookingObj({
          custId: data?.id,
          custMobile: data?.mobile,
          custName: data.fullName,
          custEmail: data.email,
          isCompanyBooking: data?.corporateClientId ? true : false,
          corporateClientId: data?.corporateClientId,
        });
      }
    });
    return () => {
      setBookingObj({});
    };
  }, []);

  const [editFlag, setEditFlag] = useState(false);

  const [customerList, setCustomerList] = useState("Trips");

  const editCustomerType = (value) => {
    let vip=false
    let coorporate=false
    if (value == "Vip") {
      vip=customerType.isVip?false:true
    }else{
      coorporate=customerType.isCorporateAccount?false:true
    }
    setCustomerType({
      isVip: vip,
      isCorporateAccount: coorporate,
      isInternational: false,
    });

  };

  const fetchBookingData = async () => {
    return null;
  };

  const editCustomerData = () => {
    const editCustomerData = getValues();
    const body = {
      email: editCustomerData.email,
      fullName: editCustomerData.fullName,
      mobile: editCustomerData.mobile,
      isInternational: customerType.isInternational,
      isVip: customerType.isVip,
      isRegistered: customerObj.isRegistered,
      isCorporateAccount: customerType.isCorporateAccount,
      createdViaType: customerObj.createdViaType,
      gender: customerObj.gender,
      city: editCustomerData.city,
      id: customerObj.id,
    };
    editCustomer(body).then((result) => {
      console.log(result);
      showAlert("success", "Saved Successfully");
      setCustomerObj((prevData) => {
        return {
          ...prevData,
          email: editCustomerData.email,
          fullName: editCustomerData.fullName,
          mobile: editCustomerData.mobile,
          city: editCustomerData.city,
          isInternational: customerType.isInternational,
          isVip: customerType.isVip,
          isCorporateAccount: customerType.isCorporateAccount,
        };
      });
      setEditFlag(false);
    });
  };

  const BookingModalToggle = () => {
    setBookingObj({
      custId: customerObj?.id,
      custMobile: customerObj?.mobile,
      custName: customerObj.fullName,
      custEmail: customerObj.email,
      isCompanyBooking: customerObj?.corporateClientId ? true : false,
      corporateClientId: customerObj?.corporateClientId,
    });
    toggleBookCabModal();
    setBookingEditType("Book");
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <div className="page-title">
          <Row>
            <Col xs="6">
              <H3>{"Customer Profile"}</H3>
            </Col>
          </Row>
        </div>

        <Row className="customer-profile">
          <Col sm="12" className="customer-info">
            <div className="customer-image">
              {/* <Image
                attrImage={{
                  className: "img-100 h-100 rounded-circle",
                  alt: "",
                  src: `${require("../../../assets/images/booking/customer.png")}`,
                }}
              /> */}
              <div className="img-100 h-100 rounded-circle profile-image-box">
            <div className="profile-image">{profileImage}</div>
          </div>
            </div>
            {editFlag ? (
              <div className="customer-content">
                <div className="animate-input">
                  <AnimatedInput
                    useformInput={true}
                    register={register}
                    registerName="fullName"
                    id="Customer Name"
                  />
                </div>
                <div className="animate-input">
                  <AnimatedInput
                    useformInput={true}
                    register={register}
                    registerName="mobile"
                    id="Phone Number"
                  />
                </div>
                <div className="animate-input">
                  <AnimatedInput
                    useformInput={true}
                    register={register}
                    registerName="email"
                    id="Email"
                  />
                </div>
                <div className="animate-input">
                  <AnimatedInput
                    useformInput={true}
                    register={register}
                    registerName="city"
                    id="City"
                  />
                </div>
              </div>
            ) : (
              <div className="customer-content">
                <div className="customer-name">
                  <H6>{customerObj.fullName}</H6>
                  <i
                    className="icofont icofont-edit-alt"
                    onClick={() => setEditFlag(true)}
                  ></i>
                </div>
                <div>
                  <span>
                    <i className="fa fa-phone"></i>
                  </span>
                  <span>+91 {customerObj.mobile}</span>
                </div>
                <div>
                  <span>
                    <i className="fa fa-envelope"></i>
                  </span>
                  <span>{customerObj.email}</span>
                </div>
                <div>
                  <span>
                    <i className="fa fa-map-marker"></i>
                  </span>
                  <span>{customerObj.city}</span>
                </div>
              </div>
            )}
            <div className="customer-content customer-data">
              <div className="customer-list">
                <span>Created on</span>:
                <span>
                  {customerObj.createdOn
                    ? moment(new Date(customerObj.createdOn)).format(
                        "MMM DD, YYYY-HH:mm:SS"
                      )
                    : "-"}
                </span>
              </div>
              <div className="customer-list">
                <span>Created Via</span>:
                <span>
                  {customerObj.createdViaType
                    ? customerObj.createdViaType
                    : "-"}
                </span>
              </div>
              {editFlag ? (
                <div className="customer-type-list edit-data">
                  <span
                    className={customerType.isVip ? "type-active" : ""}
                    onClick={() => editCustomerType("Vip")}
                  >
                    VIP
                  </span>
                  <span
                    className={
                      customerType.isCorporateAccount ? "type-active" : ""
                    }
                    onClick={() => editCustomerType("Corporate")}
                  >
                    Corporate
                  </span>
                </div>
              ) : (
                <div className="customer-type-list">
                  <span className={customerObj.isVip ? "type-active" : ""}>
                    VIP
                  </span>
                  <span
                    className={
                      customerObj.isCorporateAccount ? "type-active" : ""
                    }
                  >
                    Corporate
                  </span>
                </div>
              )}
            </div>
          </Col>
          {editFlag ? (
            <Col sm="12" className="customer-edit-btns">
              <button
                className="btn customer-edit-button"
                onClick={() => editCustomerData()}
              >
                Save
              </button>
              <button
                className="btn customer-edit-cancel-btn"
                onClick={() => setEditFlag(false)}
              >
                Cancel
              </button>
            </Col>
          ) : (
            ""
          )}
          <hr className="divider-line" />
          <Col sm="12" className="mt-3">
            <div style={{display: "flex",justifyContent: "space-between",alignItems: "center"}}>
              <h5>Bookings</h5>
              {/* <Row className="trip-options">
                <div>
                  <ul className="booking-tabs">
                    <li
                      className={`${customerList == "Trips" ? "active" : ""}`}
                      onClick={() => setCustomerList("Trips")}
                    >
                      Trips
                      <div className="arrow-down"></div>
                    </li>
                    <li
                      className={`${customerList == "Tickets" ? "active" : ""}`}
                      onClick={() => setCustomerList("Tickets")}
                    >
                      Tickets
                      <div className="arrow-down"></div>
                    </li>
                  </ul>
                </div>
                <div className="more-options animate-input">
                  <AnimatedInput
                    label={"Search"}
                    id={"SearchCustomerData"}
                    register={register}
                    name="search"
                  />
                </div>
              </Row> */}
              <div>
                <Btn
                  attrBtn={{
                    color: "primary",
                    className: "d-block w-100",
                    onClick: (e) => BookingModalToggle(),
                  }}
                >
                  Create new booking
                </Btn>
              </div>
            </div>
            <Card className="customer-profile-table">
              <CardBody className="p-0">
                {customerList == "Trips" ? (
                  <CustomerTripsTable customerId={customerId} />
                ) : (
                  // <CustomerTicketsTable />
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CustomerProfile;
